document.addEventListener('DOMContentLoaded', function () {
	// Improved and more robust counter animation with fallbacks and guards
	const runCounters = () => {
		const counters = document.querySelectorAll('.count');
		if (!counters || counters.length === 0) return;
		const defaultSpeed = 60;
		const frameMs = 20;

		const parseNumber = (val) => {
			if (val == null) return 0;
			const numeric = String(val).replace(/[^0-9.-]+/g, '');
			return numeric === '' ? 0 : Number(numeric);
		};

		const animateCount = (counter) => {
			if (!counter || counter.dataset.animated === 'true') return;
			counter.dataset.animated = 'true';

			const rawTarget = counter.getAttribute('data-target') ?? counter.dataset.target ?? counter.textContent;
			const target = Math.max(0, parseNumber(rawTarget));
			let current = Math.max(0, parseNumber(counter.textContent));
			const speed = Number(counter.dataset.speed) || defaultSpeed;
			const increment = Math.max(1, Math.ceil(target / speed));

			// Ensure starting value is numeric
			if (!current) {
				current = 0;
				counter.textContent = current.toLocaleString();
			}

			const update = () => {
				current += increment;
				if (current < target) {
					counter.textContent = current.toLocaleString();
					setTimeout(update, frameMs);
				} else {
					counter.textContent = target.toLocaleString();
				}
			};

			update();
		};

		if ('IntersectionObserver' in window) {
			const observer = new IntersectionObserver((entries, obs) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						animateCount(entry.target);
						obs.unobserve(entry.target);
					}
				});
			}, { threshold: 0.5 });

			counters.forEach(counter => observer.observe(counter));
		} else {
			// fallback for older browsers: animate immediately
			counters.forEach(animateCount);
		}
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', runCounters);
	} else {
		runCounters();
	}
});
